export const activeEvents = [
  'focus',
  'click',
  'hover',
  'scroll',
  'mouseover',
  'mouseenter',
  'mousedown',
  'dblclick',
  'keypress',
  'touchstart',
  'touchmove',
];
export const inactiveEvents = ['blur'];
